import React, {useState, useEffect} from 'react'
import '../CSS/HomePageNew.css'
import NavTablet from './NavTablet'
import anonymousIcon from '../img/anonymousIcon.png'
import communitySupportIcon from '../img/communitySupportIcon.png'
import privacyIcon from '../img/privacyIcon.png'
import { Link } from 'react-router-dom'
import { useStateValue } from '../StateProvider'; 
import Button from "@material-tailwind/react/Button";
import dash1 from '../img/dash1.jpg'
import HomePage from './HOME/HomePage'

const HomePageNew = () => {

    const [userData, setUserData] = useState(localStorage.getItem('user'));
    const [{user}] = useStateValue();
    useEffect(() => {
        setUserData(JSON.parse(window.localStorage.getItem('user')));
    }, []);

    return (
        <>
        {user || userData ? (
            <div className="newHome">
            <div className="newHomeDiv" id='newHomeDiv'>
            <div className="navDiv">
                <NavTablet />
            </div>
            <div className="newHomeDivSubDiv">
                <section className="make-section">

                       <section className="bookSession">
                           <div className="bookSessionText">
                               <h1 className="dashHead1"><b>Whatever Troubling You</b></h1>
                               <h1 className="dashHead2"> Get Help Now</h1>
                               <Link to='/AppointmentPage'>
                               <Button color="lightBlue" size="lg" ripple="light" id='getStrBtn'>Book Session Now</Button></Link>
                           </div>
                           <div className="bookSessionImage" >
                               <img src={dash1} className="img-fl" alt="Smiling Face"/>
                           </div>
                       </section>

                   </section>
            
                <div id="displayNoneHomePageNewDown">
                   <section className="make-section">
                
                    <div >
                            <h2 id='modeSeHead'>Select The Mode Of Session</h2>
                                    <div className="home-select-modeSubDiv">
                                        <div className="selectSessionMode1">
                                            <i className="far fa-comments"></i>
                                            <Link to={user ? '/AppointmentPage' : '/login_Signup'}>
                                                <div className="sessionDivText">
                                                    <h1>Online Chat Sessions</h1>
                                                    <small>Chat anonymously with an expert of your choice. This service is available to you anytime, anywhere.</small>
                                                </div>
                                            </Link>
                                        </div>

                                        <div className="selectSessionMode2">
                                            <i className="fas fa-phone-square-alt"></i>
                                            <Link to={user ? '/AppointmentPage' : '/login_Signup'}>
                                                <div className="sessionDivText">
                                                    <h1>Voice Call Sessions</h1>
                                                    <small>Chat anonymously with an expert of your choice. This service is available to you anytime, anywhere.</small>
                                                </div>
                                            </Link>
                                        </div>

                                        <div className="selectSessionMode3">
                                            <i className="fa fa-fas fa-video"></i>
                                            <Link to={user ? '/AppointmentPage' : '/login_Signup'}>
                                                <div className="sessionDivText">
                                                    <h1>Video Call Sessions</h1>
                                                    <small>Chat anonymously with an expert of your choice. This service is available to you anytime, anywhere.</small>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                            </div> 
                  
                   </section>

                     <div className="newHomePageRow">
                        <div className="feature-box">
                            <img src={privacyIcon} alt="Privacy Matters" className="privacyImage"/>
                            <h3 className="feature-box-heading">
                                <b>Private and Confidential</b>
                            </h3>
                        </div>
                        <div className="feature-box">
                            <img src={communitySupportIcon} alt="Privacy Matters" className="privacyImage"/>
                            <h3 className="feature-box-heading">
                                <b>Community Support</b>
                            </h3>
                        </div>
                        <div className="feature-box">
                            <img src={anonymousIcon}  alt="Privacy Matters" className="privacyImage"/>
                            <h3 className="feature-box-heading">
                                <b>Anonymous Discussions</b>
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        
       
        ) : (
            <HomePage />
        )}
    </>
    )
}

export default HomePageNew
